// extracted by mini-css-extract-plugin
export default {"header":"updateStocksOrders_header__uPbyC","form":"updateStocksOrders_form__U-u4q"};